// SignIn.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

const { styled, Card, Stack } = mui;

const CustomCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  maxWidth: '450px',
  padding: `${theme.spacing(4)} ${theme.spacing(4)}`, // Top-bottom: XXpx, Left-right: YYpx
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
  height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
  minHeight: '100%',
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4),
  },
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}));

export default function SignIn(props) { 

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();
  
  // const CustomCard = styled(Card)(({ theme }) => ({
  //   display: 'flex',
  //   flexDirection: 'column',
  //   alignSelf: 'center',
  //   width: '100%',
  //   maxWidth: '450px',
  //   padding: `${theme.spacing(4)} ${theme.spacing(4)}`, // Top-bottom: XXpx, Left-right: YYpx
  //   gap: theme.spacing(2),
  //   margin: 'auto',
  //   [theme.breakpoints.up('sm')]: {
  //     maxWidth: '450px',
  //   },
  //   boxShadow:
  //     'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  //   ...theme.applyStyles('dark', {
  //     boxShadow:
  //       'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  //   }),
  // }));

  // const SignInContainer = styled(Stack)(({ theme }) => ({
  //   height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
  //   minHeight: '100%',
  //   padding: theme.spacing(2),
  //   [theme.breakpoints.up('sm')]: {
  //     padding: theme.spacing(4),
  //   },
  //   '&::before': {
  //     content: '""',
  //     display: 'block',
  //     position: 'absolute',
  //     zIndex: -1,
  //     inset: 0,
  //     backgroundImage:
  //       'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
  //     backgroundRepeat: 'no-repeat',
  //     ...theme.applyStyles('dark', {
  //       backgroundImage:
  //         'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
  //     }),
  //   },
  // }));

  const navigate = useNavigate();
  
  const dispatch = useDispatch(); // dispatch(
  //const usernameErrorMessage = useSelector((state) => state.signIn.usernameErrorMessage);
  //const passwordErrorMessage = useSelector((state) => state.signIn.passwordErrorMessage);
  //const username = useSelector((state) => state.signIn.username);
  //const password = useSelector((state) => state.signIn.password);
  //const passwordError = useSelector((state) => state.signIn.passwordError);
  //const usernameError = useSelector((state) => state.signIn.usernameError);
  const loading4Home = useSelector((state) => state.home.loading4Home);
  const userListItem = useSelector((state) => state.home.userListItem);

  const [username, setUsername] = useState('');
  const [usernameError, setUsernameError] = useState(false);
  const [usernameErrorMessage, setUsernameErrorMessage] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
  const [error, setError] = useState(false);
  const [errorMessage, seterrorMessage] = useState('');

  const handleSubmit = (e) => {

    // deleteLogListItem();

    e.preventDefault();
    if (username && password) {
      // dispatch(setLoading4Home(true));
      //authenticationService
      getToken(username, password, 1440) // 24 hours expire
      //.then(getUserListItem('SignIn'))
      .then((token) => {
        if (token.length > 0) {
          dispatch(reset4Home());
          dispatch(reset4Book());
          dispatch(reset4Chapter());
          dispatch(reset4Verse());    
          dispatch(reset4ChipArray());
          dispatch(reset4Dialog2());
          dispatch(reset4Dialog4());
          dispatch(reset4Search());
          dispatch(reset4Switch1());
          dispatch(reset4verseLabelArrows4Result());
          dispatch(reset4NoteBookmarkVerseList());
          dispatch(reset4NoteBookmarkList());
          dispatch(reset4GoToTopButtonVisible());
          dispatch(reset4ConfirmationDialog());
          dispatch(reset4Profile());
          dispatch(reset4NoteSearch());
          const credential = {
            UserName: username,
            Token: token
          };
          dispatch(setCredential(credential));
          //getUserListItem('SignIn');
          // dispatch(setLoading4Home(false));
          navigate('/home');
          //handleSignIn();
        } else {
          setError(true);
          seterrorMessage('帳戶名稱或密碼錯誤，請重新輸入');
          // dispatch(setLoading4Home(false));
        }
      })
    }
    else {
      setError(true);
      seterrorMessage('帳戶名稱或密碼錯誤，請重新輸入');
      // dispatch(setLoading4Home(false));
    }
  };

  const validateInputs = async () => {

    setUsernameError(false);
    setPasswordError(false);
    setError(false);

  };

  useEffect(() => {
    dispatch(reset4SignIn());
  }, []);

  return (
    <div style={{ paddingTop: '100px', paddingLeft: '25px', paddingRight: '25px' }}>
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      {/* <SignInContainer direction="column" justifyContent="space-between"> */}
        <CustomCard variant="outlined">
          <Typography
            component="h1"
            variant="h4"
            sx={{ width: '100%' }}
          >
            「聖經筆記網」登入帳戶
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 2,
            }}
          >
            <FormControl>
              <FormLabel htmlFor="username">帳戶名稱</FormLabel>
              <TextField
                error={usernameError}
                helperText={usernameErrorMessage}
                id="username"
                type="username"
                name="username"
                // placeholder="peterchan"
                autoComplete="username"
                //autoFocus
                required
                fullWidth
                variant="outlined"
                color={usernameError ? 'error' : 'primary'}
                onChange={e => setUsername(e.target.value)}
                value={username}
              />
            </FormControl>

            <FormControl>
              <FormLabel htmlFor="password">密碼</FormLabel>
              <TextField
                error={passwordError}
                helperText={passwordErrorMessage}
                name="password"
                // placeholder="••••••"
                type="password"
                id="password"
                autoComplete="current-password"
                //autoFocus
                required
                fullWidth
                variant="outlined"
                color={passwordError ? 'error' : 'primary'}
                onChange={e => setPassword(e.target.value)}
                value={password}
              />
            </FormControl>
            
            <Button
              type="submit"
              fullWidth
              variant="contained"
              onClick={validateInputs}
            >
              登入
            </Button>
            
            <Typography sx={{ textAlign: 'center', color: 'red' }}>
              {error && errorMessage}
            </Typography>

            <Typography sx={{ textAlign: 'right', fontSize: '12px', color: 'gray' }}>
              {VERSION}
            </Typography>            

            <Link
                to='/password-reset'
                variant='body2'
                sx={{ alignSelf: 'center' }}
            >
              忘記密碼？
            </Link>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography sx={{ textAlign: 'center' }}>
              未有帳戶嗎？{' '}
              <Link
                to='/sign-up'
                variant='body2'
                sx={{ alignSelf: 'center' }}
              >
                建立帳戶
              </Link>
            </Typography>
          </Box>
        </CustomCard>

      {/* </SignInContainer> */}
    </AppTheme>

    {loading4Home && <ClipLoader1 />}

    </div>
  );
}